import { jsx, jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { Collapse, Icon, Typography } from "@perxis-auto/ui-kit/lib";
import { ModelCheckbox } from "@perxis-auto/ui-kit/lib/components/ModelCheckbox";
import clsx from "clsx";
import { usePrepareModalCheckboxGroupProps } from "../../../../features/filterValues/lib/hooks/usePrepareModalCheckboxGroupProps.js";
import "@perxis-auto/shared/lib";
import "@perxis-auto/shared";
import "../../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/ui-kit";
import "../../../../shared/config/env.js";
import "../../../../shared/config/events.js";
import "../../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../../shared/lib/store/createAppApi.js";
import "../../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../../shared/lib/store/createAppSelector.js";
import "../../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../../shared/lib/store/hooks/useAppStore.js";
import "../../../../shared/store/config/middleware/index.js";
import "../../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../../shared/store/config/model/selectors/selectGeo.js";
import "../../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../../shared/store/config/model/selectors/selectMaps.js";
import { selectModels } from "../../../../shared/store/config/model/selectors/selectModels.js";
import "../../../../shared/store/config/model/selectors/selectSort.js";
import "../../../../shared/store/config/model/selectors/selectTags.js";
import "../../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../../shared/store/config/model/slice.js";
import styles from "./FilterModels.module.scss.js";
function FilterModels({
  className,
  type = "primary",
  layout = "compact",
  checkboxLayout = "check-icon",
  gutter = [8, 8],
  xs = 24,
  sm = 12,
  md = 24,
  ...props
}) {
  const [activeKey, setActiveKey] = useState([]);
  const { useGroupingByBrand } = useAppSelector(selectModels);
  const { value: values, options, groupedOptions, ...filterProps } = usePrepareModalCheckboxGroupProps(props);
  useEffect(() => {
    setActiveKey(groupedOptions.map(([brand]) => brand.id));
  }, [groupedOptions.length]);
  if (!useGroupingByBrand) {
    return /* @__PURE__ */ jsx(
      ModelCheckbox.Group,
      {
        type,
        layout,
        checkboxLayout,
        gutter,
        xs,
        sm,
        md,
        value: values,
        options,
        className: clsx(styles.filterModels, className),
        ...filterProps
      }
    );
  }
  return /* @__PURE__ */ jsx(
    Collapse,
    {
      activeKey,
      onChange: (key) => setActiveKey(Array.isArray(key) ? key : [key]),
      items: groupedOptions.map(([brand, { value = [], options: options2 = [], ...groupedProps }]) => {
        return {
          key: brand.id,
          label: /* @__PURE__ */ jsxs("div", { className: styles.filterModelsCollapse__brandHeader, children: [
            brand.imgSrc ? /* @__PURE__ */ jsx("img", { src: brand.imgSrc, alt: brand.imgAlt }) : /* @__PURE__ */ jsx(Typography.Title, { level: "h5", color: "darkest", className: styles.filterModelsCollapse__brandTitle, children: brand.title }),
            !!brand.description && /* @__PURE__ */ jsx(
              Typography.Paragraph,
              {
                level: "super-small",
                color: "dark-light",
                className: styles.filterModelsCollapse__brandDescription,
                children: brand.description
              }
            )
          ] }),
          children: /* @__PURE__ */ jsx(
            ModelCheckbox.Group,
            {
              type,
              layout,
              checkboxLayout,
              gutter,
              xs,
              sm,
              md,
              ...filterProps,
              ...groupedProps,
              value,
              options: options2,
              className: clsx(styles.filterModels, className)
            }
          )
        };
      }),
      expandIcon: ({ isActive }) => /* @__PURE__ */ jsx(Icon, { name: isActive ? "minus" : "plus", sticker: "parameters-expand-icon", size: 20 }),
      classNameWrapper: styles.filterModelsCollapse
    }
  );
}
export {
  FilterModels
};
